<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="21.84" height="21.431" viewBox="0 0 21.84 21.431">
    <g transform="translate(-1268.141 -832.953)">
      <path
        d="M1279.062,846.247c-1,0-4.438-.492-10.465-6.25l-.456-.435.528-.345c2.975-1.941,9.236-6.012,9.236-6.012l.387-.252.282.366a13.347,13.347,0,0,0,11.134,5.222l.273.931c-5.008,2.965-10.368,6.638-10.421,6.675l-.2.081A2.03,2.03,0,0,1,1279.062,846.247Zm-9.315-6.539c5.738,5.342,8.779,5.562,9.357,5.539.712-.485,4.731-3.213,8.889-5.747a14.443,14.443,0,0,1-9.924-5.209C1276.761,835.142,1272.384,837.988,1269.747,839.708Z"
      />
      <path
        d="M1279.116,850.415l-.181-.023c-4.242-.548-9.041-5.58-9.244-5.794l.727-.688c.047.049,4.616,4.839,8.467,5.464,2.59-1.684,7.785-5.484,7.839-5.523l.589.806c-.053.04-5.488,4.017-8.043,5.659Z"
      />
      <path
        d="M1278.948,854.384l-.151-.01c-4.282-.28-8.9-4.93-9.1-5.128l.713-.7c.044.045,4.437,4.462,8.3,4.819,2.8-1.635,7.794-4.855,7.845-4.888l.543.839c-.052.034-5.225,3.373-8.021,4.993Z"
      />
    </g>
  </svg>
</template>
